module.exports = __webpack_public_path__ + "images/emoji/honeybee.0dfe0eee3d2d13171e1e.png";